// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KhZ-","colBig":"styles_colBig__bH-eB","colSmall":"styles_colSmall__19CJO","shopifyNameWrapper":"styles_shopifyNameWrapper__1QUH8"};